import { notificationInstance } from './notificationInstance';

export const sendNotificationEmail = async (subject: string, body: string): Promise<void> => {
  try {
    await notificationInstance.get('/', {
      params: {
        subject,
        body,
      },
    });
    // eslint-disable-next-line no-console
    console.log('Notification email sent successfully');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error sending notification email:', error);
  }
};
